import React from "react"
import { graphql } from 'gatsby'
import Scrollspy from 'react-scrollspy'
import Img from 'gatsby-image'
import { Link as ScrollLink } from 'react-scroll'
import Layout from "../components/layout"
import SEO from "../components/seo"
// import Sponsor from "../components/sponsor"
// import Newsletter from "../components/newsletter"
import { Link } from '../components/localizedlink'
import AutoAffix from '../utility/affix/AutoAffix'
import Banner from '../components/banner'
import RichiediReport from "../components/richiedi-report"

const Report2019 = ({ pageContext: { locale }, data }) => {
  return (
    <Layout locale={locale}>
      <SEO title="Executive summary IIC 2019" bodyClass="header-testata site-white" />
      <section className="section evento evento--iic hero-testata">
        <Img className="evento__img" loading="eager" fluid={data.hero.childImageSharp.fluid} alt="" />
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <div className="hero-video__content">
                <div className="hero-intro hero-intro--iic">
                  <div className="hero-intro__edition">3° Edizione</div>
                  <div className="hero-intro__title text-uppercase" itemProp="name">Intranet Italia Champions</div>
                  <div className="hero-intro__date">19-20 Mmggio 2022</div>
                  <div className="hero-intro__subject">Il premio per le migliori iniziative intranet italiane</div>
                  <div className="hero-intro__claim">
                    Evento ideato da Giacomo Mason di <a href="https://www.intranetmanagement.it/" title="Intranet Management" target="_blank" rel="noopener noreferrer">Intranet Management</a>,  <br className="d-none d-lg-block" />azienda parte di <a href="https://www.ariadnegroup.it/" title="Ariadne Group" target="_blank" rel="noopener noreferrer">Ariadne Group</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="bg-fagioloni bg-fagioloni--offset bg-fagioloni--iic">
        <div className="bg-fagioloni__left"></div>
        <div className="bg-fagioloni__right"></div>

        <div className="champions">
          <div className="container">
            <div className="row">
              <div className="d-none d-md-block col-md-5 col-lg-4 col-xl-3 text-center">
                <AutoAffix affixClassName="sidebar sidebar--affix" topClassName="sidebar sidebar--affix-top" bottomClassName="sidebar sidebar--affix-bottom"
                  viewportOffsetTop={220} container={() => document.getElementById('scrollContainer')}>
                  <div>
                    <div className="left-nav--primary"><Link to="/premio-iic-2019/#champions">Premio IIC 2019</Link></div>
                    <div className="left-nav--primary left-nav__primary--active">Report 2019</div>
                    <nav className="left-nav">
                      <Scrollspy items={['vincitori', 'casestudy', 'tendenze', 'report']} offset={-220}
                        className="left-nav__list" currentClassName="active">
                        <li className="left-nav__item left-nav__item--1">
                          <ScrollLink href="vincitori" to="vincitori" smooth={true} title="i vincitori" className="left-nav__link">Progetti vincenti</ScrollLink>
                        </li>
                        <li className="left-nav__item left-nav__item--2">
                          <ScrollLink href="casestudy" to="casestudy" smooth={true} title="Casi di studio" className="left-nav__link">Casi di studio</ScrollLink>
                        </li>
                        <li className="left-nav__item left-nav__item--3">
                          <ScrollLink href="tendenze" to="tendenze" smooth={true} title="Le 8 tendenze del 2019" className="left-nav__link">Alcune tendenze</ScrollLink>
                        </li>
                        <li className="left-nav__item left-nav__item--4">
                          <ScrollLink href="report" to="report" smooth={true} title="Report 2019" className="left-nav__link">Richiedi il report</ScrollLink>
                        </li>
                      </Scrollspy>
                    </nav>
                    <div className="left-nav--primary"><Link to="/intranet-italia-champions/#champions">Che cos'è IIC</Link></div>
                  </div>
                </AutoAffix>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-7 col-xl-7">
                <div className="champions__text" id="scrollContainer">
                  <section id="vincitori" className="section section--pt">
                    <h1 className="section__title">IIC Executive Summary</h1>
                    <p>
                      I 4 vincitori assoluti della prima edizione (2019) dell’IIC sono:
                    </p>
                    <ul>
                      <li><strong>Angelini Group</strong></li>
                      <li><strong>Fastweb</strong></li>
                      <li><strong>Rai</strong></li>
                      <li><strong>Ferrero</strong></li>
                    </ul>
                    <p>
                      Queste aziende hanno creato, ciascuna nel proprio ambito, progetti di grande interesse sotto il profilo del design, dei contenuti o delle funzionalità intranet. In una parola, dell’innovazione nella comunicazione interna.
                      <br />
                      Ecco una breve descrizione dei progetti vincenti dell’edizione 2019 del premio:
                    </p>
                    <p>
                      <strong>Angelini Group</strong> - Un nuovo digital workplace.<br />
                      Angelini ha realizzato un digital workplace di grande complessità, con un design molto ben curato e un processo di ideazione realmente inclusivo, che ha coinvolto i dipendenti e
                      ha tenuto conto dei loro bisogni. La forte profilazione, l’e-commerce dedicato al personale e l’ottima versione mobile fanno
                      di questa intranet un progetto davvero riuscito.
                    </p>
                    <Img fluid={data.angelini.childImageSharp.fluid} alt="Angelini Group" className="champions__img" />

                    <p>
                      <strong>Fastweb</strong> - Una App per il desk booking.<br />
                      Fastweb ha creato un’applicazione a supporto di un processo innovativo dell’azienda (il cambio delle modalità di lavoro nella nuova sede), riuscendo a migliorare la vita delle persone e
                      a coinvolgerle nel processo di design. Oggi i dipendenti hanno uno strumento evoluto ed inclusivo per supportare la collaborazione e favorire l’evoluzione verso il “working smarter”.
                    </p>
                    <Img fluid={data.fastweb.childImageSharp.fluid} alt="Fastweb" className="champions__img" />

                    <p>
                      <strong>Ferrero</strong> - Un digital workplace evoluto, profilato e multilingua.<br />
                      Ferrero ha raccolto la sfida di realizzare un unico portale profilato in 10 lingue diverse, per impiegati e operai, e di arrivare al singolo
                      individuo, e l’ha vinta egregiamente. Il design, la personalizzazione, le applicazioni e le iniziative realizzate fanno di questo progetto un digital workplace evoluto e di qualità.
                    </p>
                    <Img fluid={data.ferrero.childImageSharp.fluid} alt="Ferrero" className="champions__img" />

                    <p>
                      <strong>Rai - RaiPlace</strong> - Gestione presenze, formazione e informazioni.<br />
                      La Rai ha creato un portale sofisticato e polifunzionale, capace di dialogare con i diversi sistemi dell’azienda e di creare una user experience unica e gradevole per il dipendente.
                      La gestione delle presenze online, la my page, le notifiche integrate, la formazione sono tasselli importanti di un percorso verso l’efficienza e la centralità delle persone in azienda.
                    </p>
                    <Img fluid={data.rai.childImageSharp.fluid} alt="Rai - RaiPlace" className="champions__img" />
                  </section>

                  <section id="casestudy" className="section">
                    <h1 className="section__title">Casi di studio </h1>
                    <p>
                      Di seguito riportiamo i 12 progetti che, nelle diverse categorie del premio, hanno espresso elementi di grande interesse e ispirazione per chiunque si occupi di progetti intranet. Si tratta di realizzazioni <strong>interessanti e innovative e, in qualche caso, con soluzioni originali ed efficaci</strong>.
                    </p>
                    <p>
                      <strong>Banca Sella</strong> - Valori aziendali e logica multicanale.<br />
                      Banca Sella ha saputo sfruttare un approccio multicanale per dare forza e sostenere la propria campagna valori. Il coinvolgimento diretto del management nella comunicazione, l’apertura di community tematica e la presenza del midddle management nella definizione del “campo di gioco” hanno contribuito al successo dell’iniziativa.
                    </p>
                    <Img fluid={data.case_sella_homei.childImageSharp.fluid} alt="Banca Sella" className="champions__img" />

                    <p>
                      <strong>Generali Italia</strong> - Organigramma, social wall e web radio.<br />
                      Generali Italia ha realizzato un robusto redesign della intranet, con alcuni contenuti ben ideati
                      e ottimamente presentati, a partire dall’organigramma navigabile, dal social wall, dalla web radio interna commentabile. Nel complesso, un progetto che unisce efficacia ed engagement.
                    </p>
                    <Img fluid={data.case_generali.childImageSharp.fluid} alt="Generali italia" className="champions__img" />

                    <p>
                      <strong>IMA</strong> - Aree di settore e contenuti targettizzati.<br />
                      IMA ha creato un complesso sistema di aree e divisioni per distribuire contenuti e servizi in
                      modo profilato a partire da diverse applicazioni integrate. Il modello emergente permette di gestire contenuti e servizi in modo capillare e geolocalizzato.
                    </p>
                    <Img fluid={data.case_ima.childImageSharp.fluid} alt="IMA" className="champions__img" />

                    <p>
                      <strong>IREN</strong> - Progetto valori e video autoprodotti.<br />
                      Iren è riuscita a creare un progetto dedicato ai valori costruito collaborativamente e portato avanti con idee e iniziative di grande impatto e di alta complessità. I video realizzati dai collegi sono di buon livello e la partecipazione è stata molto alta.
                    </p>
                    <Img fluid={data.case_iren.childImageSharp.fluid} alt="IREN" className="champions__img" />

                    <p>
                      <strong>Poste Italiane</strong> - La nazionale di calcio di Poste italiane.<br />
                      Poste ha creato una campagna online ingaggiante, su un tema popolare (sebbene prevalentemente maschile), e capace di protrarsi nel tempo. L’associazione tra la squadra e il “fare squadra”, unita al reclutamento “a bassa soglia” fanno di questa iniziativa una metafora potente dell’attuale corso dell’azienda.
                    </p>
                    <Img fluid={data.case_poste.childImageSharp.fluid} alt="Poste Italiane" className="champions__img" />

                    <p>
                      <strong>TIM</strong> - La campagna per l’inclusione.<br />
                      Tim è riuscita a creare un’iniziativa di grandissimo
                      impatto, coinvolgendo i dipendenti nella ideazione e realizzazione di progetti di inclusione e mettendo bene a frutto un mix di strumenti
                      tra l’online e l’off line. Il risultato sono tantissimi progetti locali portati avanti dai singoli colleghi, con grande interesse di tutta la popolazione aziendale.
                    </p>
                    <Img fluid={data.case_tim.childImageSharp.fluid} alt="TIM" className="champions__img" />

                    <p>
                      <strong>Gruppo Aboca</strong> - Una APP inclusiva per i dipendenti.<br />
                      La App di Aboca riesce finalmente a raggiungere tutti i dipendenti dell’azienda, realizzando una vera inclusione nel processo di comunicazione interna. Le funzionalità di rubrica, idee e prenotazione mensa la rendono utile e ingaggiante per tutti i dipendenti.
                    </p>
                    <Img fluid={data.case_aboca.childImageSharp.fluid} alt="Gruppo Aboca" className="champions__img" />

                    <p>
                      <strong>Aeroporto di Bologna</strong> - Una intranet TV geolocalizzata.<br />
                      Aeroporto di Bologna ha creato un sistema di distribuzione delle informazioni multi-channel e davvero pensato per i destinatari. I monitor, assieme agli altri canali, forniscono una digital experience fluida e profilata sulle diverse categorie di colleghi, aumentando l’efficacia dei contenuti. Informazioni di servizio e storie personali sono ben costruite in un mix ad alto tasso di engagement.
                    </p>
                    <Img fluid={data.case_adb.childImageSharp.fluid} alt="Aeroporto di Bologna" className="champions__img" />

                    <p>
                      <strong>ISTAT</strong> - Gestione online delle prenotazioni HR<br />
                      L’Istat ha attivato, sulla propria intranet, un nuovo servizio dedicato alla prenotazione online degli appuntamenti per presentare la documentazione e protocollare le domande relative ai contributi socio-assistenziali di cui può beneficiare il personale interno. Un risparmio di carta e di tempo e la fine delle code allo sportello interno per protocollare le domande.
                    </p>
                    <Img fluid={data.case_istat.childImageSharp.fluid} alt="ISTAT" className="champions__img" />

                    <p>
                      <strong>Fater</strong> - Social intranet, gamification e social collaboration.<br />
                      Fater è riuscita a creare un sofisticato spazio social di collaborazione senza dimenticare le necessità operative di documenti, accesso alle applicazioni, servizi al dipendente. In questo equilibrio tra social e servizio la intranet di Fater ha avuto successo. L’aggancio a standard di interazione conosciuti (es. Facebook) ha aiutato l’adozione e l’utilizzo tra i dipendenti.
                    </p>
                    <Img fluid={data.case_fater.childImageSharp.fluid} alt="Fater" className="champions__img" />

                    <p>
                      <strong>Sky Italia</strong> - Restyling, nuovi format editoriali e indice A-Z per la intranet.<br />
                      Sky Italia ha realizzato un restyling che elimina alla radice il vecchio concetto di navigazione principale e lo sostituisce con un efficace modello a “indice” associato alla ricerca. I format di comunicazione ideati sono freschi e coinvolgenti.
                    </p>
                    <Img fluid={data.case_sky.childImageSharp.fluid} alt="Sky Italia" className="champions__img" />

                    <p>
                      <strong>SUPSI</strong> - Un portale personalizzato per i collaboratori.<br />
                      SUPSI ha realizzato appieno le potenzialità che oggi offre un digital workplace evoluto: spazi con informazioni personali integrate da altri sistemi e fornite in modo coerente e usabile, spazi di collaborazione e strumenti per i team, gestione documentale evoluta e interazione spinta sulle informazioni. Il tutto presentato con estrema semplicità.
                    </p>
                    <Img fluid={data.case_supsi.childImageSharp.fluid} alt="SUPSI" className="champions__img" />

                  </section>

                  <section id="tendenze" className="section">
                    <h1 className="section__title">Alcune tendenze</h1>
                    <p>
                      Possiamo identificare alcune tendenze all’interno dei casi che sono arrivati quest’anno? In effetti possiamo incontrarne qualcuna, alcune delle quali presenti anche in ambito internazionale, che si notano anche nei progetti che abbiamo potuto esaminare.
                      <br />
                      Di seguito identifichiamo le principali.
                    </p>

                    <p>
                      <strong>Formazione in prima linea.</strong> Sempre più spesso i progetti intranet presentano al loro interno delle aree dedicate alla formazione particolarmente ben fatte, come ad esempio quelle di <strong>Rai, Angelini e Ferrero</strong>. A volte si tratta di librerie di materiali, oppure di pillole video, di cataloghi di corsi fino ad arrivare a vere e proprie piattaforme di e-learning integrate nella intranet. A volte come nel caso di <strong>Fater</strong>, la formazione si configura come un “percorso” sulla intranet per acquisire nuovi skill necessari all’adozione di un nuovo modo di lavorare.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_rai_academy.childImageSharp.fluid} alt="Rai academy" />
                      <figcaption>Il catalogo corsi di Rai Academy</figcaption>
                    </figure>
                    <p>
                      <strong>L’arrivo delle APP.</strong>
                      Sebbene la maggior parte delle aziende si approcci al tema della mobilità adottando versioni responsive delle intranet piuttosto che App (per vari motivi di ottimizzazione), cominciano ad affacciarsi progetti verticali di vere e proprie APP che, in molti casi, affiancano la intranet desktop (e responsive) per l’esecuzione di task e attività. È il caso ad esempio di <strong>Fastweb</strong> ma anche di <strong>Aboca</strong>, oltre che di altri casi che sono arrivati.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.case_aboca.childImageSharp.fluid} alt="Aboca" />
                      <figcaption>La intranet app di Aboca</figcaption>
                    </figure>

                    <p>
                      <strong>Personalizzazione spinta.</strong>
                      Molti progetti intranet cominciano ad utilizzare in modo sofisticato le opzioni di personalizzazione dell’ambiente interno: link preferiti, widget, opzioni di filtro sono ormai moneta corrente nei progetti. È ad esempio il caso di <strong>Rai, Angelini, Ferrero, SUPSI</strong> e molti altri.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_angelini.childImageSharp.fluid} alt="Angelini" />
                      <figcaption>Un esempio di personalizzazione sulla intranet di Angelini</figcaption>
                    </figure>

                    <p>
                      <strong>Contenuti targhetizzati.</strong>
                      La intranet si fa sempre più sofisticata e capace di arrivare a un pubblico di dipendenti diversificato sulla base delle diverse appartenenze di settore o di nazione. I progetti di <strong>IMA</strong> e di <strong>Ferrero</strong>, di <strong>Aeroporti di Bologna</strong> esprimono bene questa tendenza alla profilazione spinta per fornire contenuti pertinenti ed eliminare il “rumore”.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_adb.childImageSharp.fluid} alt="Aereoporto di Bologna" />
                      <figcaption>Contenuti targhettizzati nella intranet sugli schermi dell’aeroporto di Bologna</figcaption>
                    </figure>

                    <p>
                      <strong>Online e oThine si incontrano.</strong>
                      In molti casi la barriera tra offline e online si va assottigliando: molti progetti nascono online e finiscono “live” o viceversa, oppure semplicemente mostrano una grande cooperazione in queste due aree della comunicazione interna. Questa forte integrazione tra mondo fisico e mondo digitale è, forse, il tratto caratteristico dei progetti italiani rispetto ai progetti stranieri, e lo si nota ad esempio nei progetti di <strong>Poste Italiane, Tim, Banca Sella, Iren</strong>.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_iren.childImageSharp.fluid} alt="IREN" />
                      <figcaption>Progetto Valori in Iren</figcaption>
                    </figure>

                    <p>
                      <strong>Nuovi formati editoriali.</strong>
                      Al di là di news e avvisi, le intranet cominciano a fornire contenuti multimediali di ottimo livello, sia audio che video, e iniziative editoriali sofisticate, come nel caso di <strong>Sky</strong> o di <strong>Generali Italia</strong>.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_sky.childImageSharp.fluid} alt="SKY" />
                      <figcaption>“Sfida l’esperto”, uno dei tanti format presenti sulla intranet di Sky.</figcaption>
                    </figure>

                    <p>
                      <strong>Social diffuso.</strong>
                      Gli elementi social, legati alle evoluzioni della rete negli ultimi anni, cominciano ad essere accettati con una certa naturalezza anche all’interno, dai commenti e like alle news (presenti ad esempio in <strong>Sky</strong>, <strong>Fastweb</strong>, <strong>Poste</strong>, <strong>Tim</strong>, fino ad arrivare a vere community fatte di gruppi di discussione e collaborazione, come nel caso di <strong>Fater</strong> o di <strong>Generali</strong>.
                    </p>

                    <figure className="champions__img">
                      <Img fluid={data.tendenze_generali.childImageSharp.fluid} alt="Generali" />
                      <figcaption>Il "social wall" di Generali.</figcaption>
                    </figure>

                    <p>
                      <strong>Verso il digital workplace.</strong>
                      Le aziende si stanno attrezzando sempre meglio per fare della intranet la porta d’accesso ad un ecosistema applicativo integrato, che sappia dialogare con i principali sistemi interni per realizzare un vero digital workplace e un’esperienza utente fluida ed efficace per i dipendenti. Una sfida importante, che è stata raccolta ad esempio da <strong>Rai</strong>, <strong>Istat</strong> e <strong>SUPSI</strong>.
                    </p>
                    <figure className="champions__img">
                      <Img fluid={data.tendenze_rai.childImageSharp.fluid} alt="RAI" />
                      <figcaption>Rai Place</figcaption>
                    </figure>

                  </section>

                  <section id="report" className="section">
                    <h1 className="section__title">Richiedi il report 2019</h1>
                    <RichiediReport />
                  </section>

                  <Banner iic={true} />
                  {/* <Sponsor iic={true} /> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Newsletter /> */}
      </div>
    </Layout >
  );
}

export default Report2019;

export const query = graphql`
  fragment sharpReport on File {
    childImageSharp{
      fluid (maxWidth: 800, quality: 100 ){
        ...GatsbyImageSharpFluid_withWebp
      }
    }
  }
  query ReportIICQuery{
    hero: file(relativePath: { eq: "hero-iic.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 1920, quality: 100) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    angelini: file(relativePath: {eq: "contents/01angelini.png"}){
      ...sharpReport
    }
    fastweb: file(relativePath: {eq: "contents/02_fastweb.png"}){
      ...sharpReport
    }
    ferrero: file(relativePath: {eq: "contents/03_ferrero.png"}){
      ...sharpReport
    }
    rai: file(relativePath: {eq: "contents/04_rai.png"}){
      ...sharpReport
    }
    case_aboca: file(relativePath: {eq: "contents/report/case/aboca.png"}){
      ...sharpReport
    }
    case_adb: file(relativePath: {eq: "contents/report/case/adb.png"}){
      ...sharpReport
    }
    case_fater: file(relativePath: {eq: "contents/report/case/fater.png"}){
      ...sharpReport
    }
    case_generali: file(relativePath: {eq: "contents/report/case/generali.png"}){
      ...sharpReport
    }
    case_ima: file(relativePath: {eq: "contents/report/case/ima.png"}){
      ...sharpReport
    }
    case_iren: file(relativePath: {eq: "contents/report/case/iren.png"}){
      ...sharpReport
    }
    case_istat: file(relativePath: {eq: "contents/report/case/istat.png"}){
      ...sharpReport
    }
    case_poste: file(relativePath: {eq: "contents/report/case/poste.png"}){
      ...sharpReport
    }
    case_sella_homei: file(relativePath: {eq: "contents/report/case/sella-homei.png"}){
      ...sharpReport
    }
    case_sky: file(relativePath: {eq: "contents/report/case/sky.png"}){
      ...sharpReport
    }
    case_supsi: file(relativePath: {eq: "contents/report/case/supsi.png"}){
      ...sharpReport
    }
    case_tim: file(relativePath: {eq: "contents/report/case/tim.png"}){
      ...sharpReport
    }
    tendenze_adb: file(relativePath: {eq: "contents/report/tendenze/adb.png"}){
      ...sharpReport
    }
    tendenze_angelini: file(relativePath: {eq: "contents/report/tendenze/angelini.png"}){
      ...sharpReport
    }
    tendenze_generali: file(relativePath: {eq: "contents/report/tendenze/generali.png"}){
      ...sharpReport
    }
    tendenze_iren: file(relativePath: {eq: "contents/report/tendenze/iren.png"}){
      ...sharpReport
    }
    tendenze_rai: file(relativePath: {eq: "contents/report/tendenze/rai.png"}){
      ...sharpReport
    }
    tendenze_rai_academy: file(relativePath: {eq: "contents/report/tendenze/rai-academy.png"}){
      ...sharpReport
    }
    tendenze_sky: file(relativePath: {eq: "contents/report/tendenze/sky.png"}){
      ...sharpReport
    }
  }
`;

